import {translations} from 'presentation/translations-new';

const {stepsTitleMobile} = translations['pt-br'].privateFlow.bookingFlow;
const {
	neighborhood,
	specialty,
	unit,
	professional,
	exam,
	confirm,
	location: locationTitle,
} = stepsTitleMobile;

const HEADER_TITLES = {
	telehealth: [specialty, professional, confirm],
	odonto: {
		withGeo: [locationTitle, specialty, unit, professional, confirm],
		withoutGeo: [locationTitle, specialty, neighborhood, unit, professional, confirm],
	},
	exam: {
		withGeo: [locationTitle, exam, unit, professional, confirm],
		withoutGeo: [locationTitle, exam, neighborhood, unit, professional, confirm],
	},
	health: {
		withGeo: [locationTitle, specialty, unit, professional, confirm],
		withoutGeo: [locationTitle, specialty, neighborhood, unit, professional, confirm],
	},
};

const STEPS_TO_RESET_UNIT_LIST = {
	odonto: [0, 1, 2],
	exam: [0, 1, 2],
	health: [0, 1, 2],
};

export {HEADER_TITLES, STEPS_TO_RESET_UNIT_LIST};
